import {
    IcePieRangesColorCodesEnum,
    IcePieRangesColorCodesEnumMeetingRoomScoresByListings,
} from 'dashboard/enums/visuals/ice-ranges-color-codes.enum';
import { VisualsDashboardRangesColorEnum } from 'dashboard/enums/visuals/visuals-dashboard-colors.enum';

export const IcePieRangesToDashboardPieRangesColorMap: Record<IcePieRangesColorCodesEnum, VisualsDashboardRangesColorEnum> = {
    [IcePieRangesColorCodesEnum.RANGE_100]: VisualsDashboardRangesColorEnum.EMERALD,
    [IcePieRangesColorCodesEnum.RANGE_80_99]: VisualsDashboardRangesColorEnum.LIME,
    [IcePieRangesColorCodesEnum.RANGE_60_79]: VisualsDashboardRangesColorEnum.YELLOW,
    [IcePieRangesColorCodesEnum.RANGE_40_59]: VisualsDashboardRangesColorEnum.AMBER,
    [IcePieRangesColorCodesEnum.RANGE_20_39]: VisualsDashboardRangesColorEnum.ORANGE,
    [IcePieRangesColorCodesEnum.RANGE_0_19]: VisualsDashboardRangesColorEnum.RED,
};

export const IcePieRangesToDashboardPieRangesColorMapMeetingRoomScoresByListings: Record<
    IcePieRangesColorCodesEnumMeetingRoomScoresByListings,
    VisualsDashboardRangesColorEnum
> = {
    [IcePieRangesColorCodesEnumMeetingRoomScoresByListings.RANGE_100]: VisualsDashboardRangesColorEnum.EMERALD,
    [IcePieRangesColorCodesEnumMeetingRoomScoresByListings.RANGE_80_99]: VisualsDashboardRangesColorEnum.LIME,
    [IcePieRangesColorCodesEnumMeetingRoomScoresByListings.RANGE_60_79]: VisualsDashboardRangesColorEnum.YELLOW,
    [IcePieRangesColorCodesEnumMeetingRoomScoresByListings.RANGE_40_59]: VisualsDashboardRangesColorEnum.AMBER,
    [IcePieRangesColorCodesEnumMeetingRoomScoresByListings.RANGE_20_39]: VisualsDashboardRangesColorEnum.ORANGE,
    [IcePieRangesColorCodesEnumMeetingRoomScoresByListings.RANGE_0_19]: VisualsDashboardRangesColorEnum.RED,
};
